import { InjectionToken } from "@angular/core";

export const DEFAULT_COUNTRY = new InjectionToken<string>('defaultCountry', {
    providedIn: 'root',
    factory: () => ''
});